(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-hero"] && !Shopify.designMode) return;
  try {
    
// Add alt text to hero video poster images
// This is needed because Shopify's video_tag does not add alt text to the poster image
document.querySelectorAll('.page-hero-section video').forEach(function(heroVideo) {
    var posterImage = heroVideo.querySelector('img');
    posterImage.alt = 'Hero Video Poster';
});

  } catch(e) { console.error(e); }
})();
})();
